import { Box, Button, Fade, InputBase, Modal, Typography, InputAdornment, useTheme } from '@mui/material'
import { ReCaptchaV3 } from 'react-recaptcha-x'
import Toast from 'components/Toast'
import CloseIcon from 'assets/images/svg/close.svg'
import LogoIcon from 'assets/images/svg/common/logo.svg'
import { LoginBox } from 'styleds'
import { useEffect, useMemo, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import { useAppDispatch } from 'state/hooks'
import LoadingIcon from 'components/LoadingIcon'
import { login } from 'services/module/user'
import { setProfileInfo, setUserAssets } from 'state/user/actions'
import { ResponseBase } from 'services/responseBase'
import { toast } from 'react-toastify'
import { usePublicKey } from 'state/user/hooks'
import { isValidEmail } from 'utils'
import PasswordShow from 'assets/images/svg/userCenter/password-show.svg'
import PasswordClose from 'assets/images/svg/userCenter/password-close.svg'
import { socketInit, useSocket } from 'hooks/useSocket'
import { usePreviousUrl } from 'state/application/hooks'
import ThirdPartyLogin from '../ThirdPartyLogin'
import { HOST } from 'config'

export default function Login({ open = false, handleClose }: { open: boolean; handleClose: Function }) {
  const [email, setEmail] = useState('')
  const [openToken, setOpenToken] = useState(false)
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [loginLoading, setLoginLoading] = useState<boolean>(false)
  const { send } = useSocket()
  const theme = useTheme()
  const [message, setMessage] = useState('')
  const dispatch = useAppDispatch()
  const publicKey = usePublicKey()
  const previousUrl = usePreviousUrl()
  const [search] = useSearchParams()
  const redirectUrl = search.get('redirectUrl')

  const location = useLocation()

  const notIsSingleLoginPage = useMemo(() => {
    return !(location.pathname.indexOf('/login') > -1 || location.pathname.indexOf('/earlyaccess/task') > -1)
  }, [location.pathname])

  useEffect(() => {
    setEmail('')
    setPassword('')
    setShowPassword(false)
    setLoginLoading(false)
  }, [open])
  useEffect(() => {
    if (message) {
      toast.error(<Toast title={message} message={''}></Toast>)
    }
  }, [message])
  const loginSubmit = (recaptchaToken: string) => {
    setOpenToken(false)
    if (!isValidEmail(email)) {
      setLoginLoading(false)
      setMessage('Please enter correct email format')
      return
    }
    if (!publicKey) {
      setLoginLoading(false)
      setMessage('Network Error')
      return
    }
    const distinctValue = Cookies.get('sensorsdata2015jssdkcross')
    let distinctData: { [key: string]: string } = {}
    if (distinctValue) {
      try {
        distinctData = JSON.parse(distinctValue)
      } catch (e) {}
    }
    const deviceid = distinctData?.distinct_id || ''

    login({ password, username: email, recaptchaToken }, publicKey, deviceid).then((res: ResponseBase) => {
      if (res.code === 200) {
        socketInit(dispatch)

        localStorage.setItem('token', res.data)
        Cookies.set('token', res.data)
        dispatch(setProfileInfo())
        dispatch(setUserAssets())
        setTimeout(() => {
          send({})
        }, 1000)
        toast.success(res.msg)

        if (redirectUrl) {
          const decodeUrl = decodeURIComponent(redirectUrl)
          window.location.href = decodeUrl
        } else if (previousUrl) {
          let previousUrlInfo = null
          try {
            previousUrlInfo = new URL(previousUrl)
          } catch {}
          if (previousUrlInfo?.pathname === '/login') {
            // navigate('/')
            window.location.href = HOST
          } else {
            window.location.href = previousUrl
          }
        } else {
          // navigate('/')
          window.location.href = HOST
        }

        setLoginLoading(false)
        handleClose('close')
      } else {
        setLoginLoading(false)
        setMessage(res.msg)
      }
    })
  }
  return (
    <>
      <Modal open={open} closeAfterTransition>
        <Fade in={open}>
          <LoginBox>
            {notIsSingleLoginPage && (
              <img
                alt=""
                src={CloseIcon}
                onClick={() => {
                  setMessage('')
                  handleClose('close')
                }}
                className="close"
              />
            )}
            <img alt="" src={LogoIcon} className="logo" />
            <Typography variant="h1" component="div">
              Welcome to Yeeha!
            </Typography>
            <InputBase
              type="email"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
              value={email}
              placeholder="Example@email.com"
            />
            <InputBase
              type={showPassword ? 'text' : 'password'}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
              value={password}
              placeholder="Password"
              endAdornment={
                <InputAdornment
                  position="end"
                  onClick={() => {
                    setShowPassword(!showPassword)
                  }}
                >
                  <img src={showPassword ? PasswordShow : PasswordClose} alt="" />
                </InputAdornment>
              }
            />
            <Typography
              variant="subtitle2"
              sx={{ cursor: 'pointer' }}
              color={theme.colors.white}
              onClick={() => {
                setMessage('')
                handleClose('Forgot')
              }}
              component="div"
            >
              Forgot password?
            </Typography>
            <Button
              startIcon={loginLoading ? <LoadingIcon theme="dark" /> : ''}
              color="primary"
              disabled={!email || !password}
              variant="contained"
              fullWidth
              onClick={() => {
                setLoginLoading(true)
                setOpenToken(true)
              }}
              sx={{ marginTop: '1.25rem' }}
            >
              Log In
            </Button>
            <ThirdPartyLogin type="Login" />
            <Box sx={{ textAlign: 'center', marginTop: '1.5rem' }}>
              <Typography variant="body1" marginTop="24px" marginBottom="16px" color="#565656" component="div">
                No account yet?
              </Typography>
              <Button
                variant="outlined"
                onClick={() => {
                  setMessage('')
                  handleClose('SignUp')
                }}
              >
                Create one now!
              </Button>
            </Box>
          </LoginBox>
        </Fade>
      </Modal>
      {openToken && (
        <ReCaptchaV3
          action="login"
          callback={token => {
            if (typeof token === 'string') {
              loginSubmit(token)
            }
          }}
        />
      )}
    </>
  )
}
